export const TypesRemocao = {
    PREPARAREMOCAO: "PREPARAREMOCAO",
    BUSCARCONTAINER: "BUSCARCONTAINER",
    LISTCONTAINER: "LISTCONTAINER",
    RESETREMOCAO: "RESETREMOCAO",
    PICKUPPLACAVEICULO: "PICKUPPLACAVEICULO",
    PICKUPEMPILHADEIRA: "PICKUPEMPILHADEIRA",
    POSICIONAREMPILHADEIRA: "POSICIONAREMPILHADEIRA",
    LOCALPOSICIONAR: "LOCALPOSICIONAR",
    VALUELISTSEARCH: "VALUELISTSEARCH",
    SETSTATUSUNIDADE: "SETSTATUSUNIDADE",
    SETICON: "SETICON",
    SETCONDICAOUNIDADE: "SETCONDICAOUNIDADE",
}

const INITIAL = {
    $id: null,
    Sucesso: false,
    Mensagem: "",
    PassagemContainerID: 0,
    PassagemContainerNumero: "",
    CondicaoUnidade: "",
    LocalUnidade: "",
    StatusUnidade: "",
    IconNome: "",
    QuestionaRotulagem: false,
    QuestionaRestricao: false,
    Nodes: [],
    ServicosConfirmarPosicionamento: [],
    Empilhadeiras: [],
    LocaisParaPosicionamento: [],
    MotivosPickup: [],
    ParametroBusca: "",
    ListContainer: [],
    PickupPlacaVeiculo: "",
    PickupEmpilhadeira: {},
    PosicionarEmpilhadeira: {},
    LocalPosicionar: {},
    valueListSearchState: {}
}

export default function preparaRemocaoReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesRemocao.PREPARAREMOCAO:
            return {
                ...state,
                $id: action.payload.$id,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                PassagemContainerID: action.payload.PassagemContainerID,
                PassagemContainerNumero: action.payload.PassagemContainerNumero,
                CondicaoUnidade: action.payload.CondicaoUnidade,
                LocalUnidade: action.payload.LocalUnidade,
                StatusUnidade: action.payload.StatusUnidade,
                IconNome: action.payload.IconNome,
                QuestionaRotulagem: action.payload.QuestionaRotulagem,
                QuestionaRestricao: action.payload.QuestionaRestricao,
                Nodes: action.payload.Nodes,
                ServicosConfirmarPosicionamento: action.payload.ServicosConfirmarPosicionamento,
                Empilhadeiras: action.payload.Empilhadeiras,
                LocaisParaPosicionamento: action.payload.LocaisParaPosicionamento,
                MotivosPickup: action.payload.MotivosPickup,
            };
        case TypesRemocao.BUSCARCONTAINER:
            return {
                ...state,
                ParametroBusca: action.payload.ParametroBusca
            };
        case TypesRemocao.LISTCONTAINER:
            return {
                ...state,
                ListContainer: action.payload.ListContainer
            };
        case TypesRemocao.PICKUPPLACAVEICULO:
            return {
                ...state,
                PickupPlacaVeiculo: action.payload.PickupPlacaVeiculo
            };
        case TypesRemocao.PICKUPEMPILHADEIRA:
            return {
                ...state,
                PickupEmpilhadeira: action.payload.EmpilhadeiraPickupVeiculo
            };
        case TypesRemocao.POSICIONAREMPILHADEIRA:
            return {
                ...state,
                PosicionarEmpilhadeira: action.payload.EmpilhadeiraPosicionar
            };
        case TypesRemocao.LOCALPOSICIONAR:
            return {
                ...state,
                LocalPosicionar: action.payload.LocalPosicionar
            };
        case TypesRemocao.VALUELISTSEARCH:
            return {
                ...state,
                valueListSearchState: action.payload.valueListSearch,
            };
        case TypesRemocao.SETSTATUSUNIDADE:
            return {
                ...state,
                StatusUnidade: action.payload.StatusUnidade,
            };
        case TypesRemocao.SETICON:
            return {
                ...state,
                IconNome: action.payload.IconNome,
            };
        case TypesRemocao.SETCONDICAOUNIDADE:
            return {
                ...state,
                CondicaoUnidade: action.payload.CondicaoUnidade,
            };
        case TypesRemocao.RESETREMOCAO:
            return INITIAL;
        default:
            return state;
    }
}

export const RemocaoActions = {
    load,
    findContainer,
    listContainer,
    resetRemocaoState,
    setPickupPlacaVeiculo,
    setEmpilhadeiraPickupVeiculo,
    setEmpilhadeiraPosicionar,
    setLocalPosicionar,
    valueListSearch,
    setStatusUnidade,
    setIconNome,
    setCondicaoUnidade,
}

function load(dadosPreparaRemocao) {
    return {
        type: TypesRemocao.PREPARAREMOCAO,
        payload: dadosPreparaRemocao
    }
}

function valueListSearch(passagemContainerId, passagemContainerNumero) {

    return {
        type: TypesRemocao.VALUELISTSEARCH,
        payload: {
            valueListSearch: {
                id: passagemContainerId,
                PassagemContainerId: passagemContainerId,
                PassagemContainerNumero: passagemContainerNumero,
                title: passagemContainerNumero
            }
        }
    }
}

function findContainer(ParametroBusca) {

    return {
        type: TypesRemocao.BUSCARCONTAINER,
        payload: { ParametroBusca: ParametroBusca }
    }
}

function listContainer(dados) {
    return {
        type: TypesRemocao.LISTCONTAINER,
        payload: { ListContainer: dados }
    }
}

function resetRemocaoState() {
    return { type: "RESETREMOCAO" }
}

function setPickupPlacaVeiculo(placa) {
    return {
        type: TypesRemocao.PICKUPPLACAVEICULO,
        payload: { PickupPlacaVeiculo: placa }
    }
}

function setEmpilhadeiraPickupVeiculo(empilhadeira) {
    return {
        type: TypesRemocao.PICKUPEMPILHADEIRA,
        payload: { EmpilhadeiraPickupVeiculo: empilhadeira }
    }
}

function setEmpilhadeiraPosicionar(empilhadeira) {
    return {
        type: TypesRemocao.POSICIONAREMPILHADEIRA,
        payload: { EmpilhadeiraPosicionar: empilhadeira }
    }
}

function setLocalPosicionar(local) {
    return {
        type: TypesRemocao.LOCALPOSICIONAR,
        payload: { LocalPosicionar: local }
    }
}

function setStatusUnidade(status) {
    return {
        type: TypesRemocao.SETSTATUSUNIDADE,
        payload: { StatusUnidade: status }
    }
}

function setIconNome(icon) {
    return {
        type: TypesRemocao.SETICON,
        payload: { IconNome: icon }
    }
}

function setCondicaoUnidade(condicao) {
    return {
        type: TypesRemocao.SETCONDICAOUNIDADE,
        payload: { CondicaoUnidade: condicao }
    }
}
